(function () {
  /* ---------- Welcome offer: 10% off for email sign-up ---------- */
  var el = document.querySelector('[data-ws-wel]');
  if (!el) return;
  var code = el.getAttribute('data-code');
  var KEY = 'ws-wel';
  function get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  var form = document.getElementById('ws-wel-form');
  var err = el.querySelector('[data-ws-wel-err]');
  var lastFocus = null;

  function open() {
    if (!el.hidden) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.classList.add('ws-wel-on');
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    var f = el.querySelector('[data-ws-wel-step]:not([hidden]) input, [data-ws-wel-step]:not([hidden]) .ws-wel__code');
    if (f && window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { f.focus(); }, 350);
  }
  function close() {
    el.classList.remove('is-in');
    document.documentElement.classList.remove('ws-wel-on');
    setTimeout(function () { el.hidden = true; }, 300);
    if (get() !== 'joined') set('closed:' + Date.now());
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function done() {
    set('joined');
    el.querySelector('[data-ws-wel-step="form"]').hidden = true;
    el.querySelector('[data-ws-wel-step="done"]').hidden = false;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    open();
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-ws-wel-close]')) close();
    var c = e.target.closest('[data-ws-wel-copy]');
    if (c) {
      var lab = c.querySelector('[data-ws-wel-copied]');
      var ok = function () { lab.textContent = 'Copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    btn.setAttribute('aria-busy', 'true'); err.hidden = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        btn.removeAttribute('aria-busy');
        /* Shopify sometimes asks for a quick human check. Send the form normally so the shopper can complete it. */
        if (/challenge/.test(r.url)) { set('pending'); form.submit(); return; }
        return r.text().then(function (t) {
          if (r.ok) done();
          else err.hidden = false;
        });
      })
      .catch(function () { btn.removeAttribute('aria-busy'); set('pending'); form.submit(); });
  });

  /* Back from a normal form post or the human check */
  if (/customer_posted=true/.test(location.search) || (get() === 'pending' && /form_type=customer|customer_posted/.test(location.search + location.hash))) { done(); return; }

  var st = get();
  if (st === 'joined') return;
  if (st && st.indexOf('closed:') === 0 && Date.now() - Number(st.slice(7)) < 7 * 864e5) return;
  if (/[?&](discount|utm_medium=email)/.test(location.search)) return;

  var shown = false;
  function trigger() { if (shown) return; shown = true; open(); window.removeEventListener('scroll', onScroll); }
  /* Phones: wait until someone has read a good chunk of the page, and never interrupt a purchase */
  var mob = window.matchMedia('(max-width: 760px)').matches;
  function busy() { var c = document.querySelector('[data-ws-count]'); var d = document.querySelector('[data-ws-drawer]'); return (c && parseInt(c.textContent, 10) > 0) || (d && !d.hidden); }
  function tryOpen() { if (busy()) return; trigger(); }
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h > (mob ? 0.6 : 0.22)) tryOpen();
  }
  setTimeout(function () {
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(tryOpen, mob ? 45000 : 6000);
  }, 2500);
  /* Desktop: also when the pointer heads for the tab bar */
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) trigger(); });
})();
